import { render, staticRenderFns } from "./EventItemBookingList.vue?vue&type=template&id=8ff7e7aa"
import script from "./EventItemBookingList.vue?vue&type=script&lang=js"
export * from "./EventItemBookingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports